import * as React from "react";
import { useTranslation } from "react-i18next";
import { AccountsController, DashboardController, IntegrationsController } from "../../../controllers";
import { Account, FinancialYear, IntegrationType } from "../../../types";
import PageLoader from "../../Page/PageLoader";
import Panel from "../../Panel/Panel";
import ResourceTable from "../../Resource/ResourceTable";
import ResourceTableRow from "../../Resource/ResourceTableRow";
import ResourceTableRowData from "../../Resource/ResourceTableRowData";
import styled from "styled-components";
import TableWidgetWrapper from "./TableWidgetWrapper";
import NumberFormatter from "../../../utilities/NumberFormatter";
import ResourceCreatablePowerSelect from "../../Form/ResourceCreatablePowerSelect";
import CardEmptyInfo from "../../Card/CardEmptyInfo";

const Container = styled.div`
  height: 100%;
`

interface IProps {
  currency: string;
  numberFormat: string;
}

const AccountsWidget = (props: IProps) => {
  const { numberFormat } = props;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(true);
  const [accounts, setAccounts] = React.useState<Account[]>([]);

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const { accounts } = await AccountsController.getAccounts({})

      setAccounts(accounts);
    } catch (error) {
      console.error("Failed to fetch financial year summary:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <Panel className="h-full flex flex-col mb-0!" contentClasses="min-h-0 flex-1 overflow-auto" title={t('AccountsWidget::Accounts')}>
        <PageLoader />
      </Panel>
    );
  }

  const onAddAccountClick = async () => {
    try {
      const { form_data: formData } = await IntegrationsController.getForm(IntegrationType.PONTO)
      window.location.assign(`/auth/ponto?onboarding_details_id=${formData.onboarding_details_id}&action=accounts`);
    } catch (ex) {
      console.error(ex)
    }
  }

  return (
    <Container>
      <Panel className="h-full flex flex-col mb-0!" contentClasses="min-h-0 flex-1 overflow-auto" title={t('AccountsWidget::Accounts')}>
        <TableWidgetWrapper>
          <ResourceTable
            data={accounts}
            stickyHeader
            headers={[
              { title: t('AccountsWidget::Name'), sticky: true },
              { title: t('AccountsWidget::Balance'), sticky: true },
            ]}
            renderRow={(account: Account) => {
              return (
                <ResourceTableRow>
                  <ResourceTableRowData>
                    {account.name}
                  </ResourceTableRowData>
                  <ResourceTableRowData>
                    {NumberFormatter.formatCurrency(account.currency, numberFormat, account.balance)}
                  </ResourceTableRowData>
                </ResourceTableRow>
              )
            }}
            renderEmpty={<CardEmptyInfo
              icon='sack-dollar'
              description={t('AccountsWidget::No accounts have been added yet')}
              descriptionActionText={t('AccountsWidget::Add account')}
              onDescriptionActionClick={onAddAccountClick}
            />}
          />
        </TableWidgetWrapper>
      </Panel>
    </Container>
  )
}

export default AccountsWidget